__turbopack_context__.v({
  "hover": "I_Zaha_hover",
  "icon": "I_Zaha_icon",
  "label": "I_Zaha_label",
  "white": "I_Zaha_white",
  "wrapper": "I_Zaha_wrapper",
});
